/* @flow */
// $FlowFixMe
import wfp from '@bijie/web-fingerprint';

let userEmail = '';

export const setUserEmail = (data:string) => {
  userEmail = data;
};

export const getUserEmail = () => userEmail;

export const saveCurrentDeviceId = (email: string, deviceId?: string = '') => {
  setUserEmail(email);
  wfp.saveCurrentDeviceId(email, deviceId);
};

export const getInfo = (email?: string) => {
  const rawEmail = email || userEmail;
  return wfp.getInfo(rawEmail.trim().toLowerCase());
};

export default {
  setUserEmail,
  getUserEmail,
  saveCurrentDeviceId,
  getInfo,
};
